export default "__VITE_ASSET__f24c6775__"